import React, {Component} from 'react';
import {Card, Typography, Button} from 'antd';
import {observer, inject} from 'mobx-react';
import {inputField, passwordField} from './InputElements';

const {Title, Text} = Typography;

const root = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
};

const title = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#001529',
    color: 'white',
    paddingTop: 10,
    paddingBottom: 10
};

const loginCard = {
    display: 'flex',
    flex: 2,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 50,
    backgroundColor:'#fff'
   
};

const messageContainer = {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 10,
}

@inject('appStore')
@observer
export default class LoginScreen extends Component {
    render() {
        const appStore = this.props.appStore;
        const loginStore = appStore.loginStore;
        const loginCredentials = loginStore.loginCredentials;

        return (
            <div style={root}>
                <Title style={title} level={2}>
                    PubKit - KLI
                </Title>
               
                <div style={loginCard}>
                    <Card style={loginCard} title={<Title level={2}>Login</Title>}>
                    <div >
                        <div style={styles.loginField} >
                            {inputField('email', loginCredentials, true, 'loginField', 'Email')}
                        </div>
                        <div style={styles.loginField} >
                            {passwordField('password', loginCredentials, true, 'loginField', 'Password')}
                        </div>
                        <div style={{marginTop: 20}} >
                            <Button loading={false} block type="primary" onClick={this.onSubmit}>Log in</Button>
                        </div>
                        <div style={messageContainer}>
                            {this.renderMessage()}
                        </div>
                        </div>
                    </Card>
               
                </div>
            </div>
        );
    }

    renderMessage = () => {
        const store = this.props.appStore;
        const message = store.validationMessage;

        switch (store.state) {
            case 'error': {
                return (
                    <Text type="danger">{message}</Text>
                )
            }
            case 'pending': {
                return (
                    <Text type="warning">{message}</Text>
                )
            }
            case 'done': {
                return (
                    <Text>{message}</Text>
                )
            }
            default: {
                return (
                    <Text>{message}</Text>
                )
            }
        }

    }

    onSubmit = async () => {
        const store = this.props.appStore;
        await store.authenticate();
    };
}

const styles = {
    loginField: {
        padding: 10,
        width: 350
    }
}

